import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { db } from "../firebase";

import {
    doc,
    getDoc,
    updateDoc,
    serverTimestamp
} from "firebase/firestore";

import { useNavigate } from "react-router-dom";

import "../styles/AutoDashboard.css";

export default function AutoDashboard() {

    const { user } = useAuth();

    const navigate = useNavigate();

    const [driver, setDriver] = useState(null);

    const [loading, setLoading] = useState(true);

    useEffect(() => {

        if (!user) return;

        loadDriver();

    }, [user]);

    async function loadDriver() {

        const snap = await getDoc(
            doc(db, "autos", user.uid)
        );

        if (!snap.exists()) {

            navigate("/join-auto");

            return;

        }

        setDriver(snap.data());

        setLoading(false);

    }

    async function toggleOnline() {

        const newStatus = !driver.online;

        await updateDoc(
            doc(db, "autos", user.uid),
            {

                online: newStatus,

                available: newStatus,

                updatedAt: serverTimestamp()

            }
        );

        setDriver({

            ...driver,

            online: newStatus,

            available: newStatus

        });

    }

    if (loading)
        return <p>Loading...</p>;

    return (

        <div className="auto-dashboard">

            <div className="driver-card">

                <img

                    src={
                        driver.photo ||

                        "https://via.placeholder.com/120"
                    }

                    alt=""

                    className="driver-photo"

                />

                <h2>{driver.driverName}</h2>

                <p>{driver.autoNumber}</p>

                <p>{driver.serviceArea}</p>

                <p>

                    ⭐ {driver.rating?.toFixed(1)}

                </p>

            </div>

            <div className="status-box">

                {driver.verified ?

                    <span className="verified">

                        ✅ Verified

                    </span>

                    :

                    <span className="pending">

                        ⏳ Waiting for Approval

                    </span>

                }

            </div>

            {driver.verified && (

                <button

                    className={
                        driver.online
                            ? "online-btn"
                            : "offline-btn"
                    }

                    onClick={toggleOnline}

                >

                    {

                        driver.online

                            ?

                            "🟢 Online"

                            :

                            "⚪ Go Online"

                    }

                </button>

            )}

            <div className="stats">

                <div>

                    <h3>

                        {driver.totalTrips}

                    </h3>

                    <p>Total Trips</p>

                </div>

                <div>

                    <h3>

                        ₹{driver.totalEarned}

                    </h3>

                    <p>Earnings</p>

                </div>

            </div>

            <button

                className="ride-btn"

                onClick={() =>
                    navigate("/ride-requests")
                }

            >

                Ride Requests

            </button>

            <button

                className="edit-btn"

                onClick={() =>
                    navigate("/join-auto")
                }

            >

                Edit Profile

            </button>

        </div>

    );

}